import React, { useState, useEffect } from 'react';
import Layout from 'Component/Layouts/layout';
import { Box, Button, Switch, Typography, Card, CardContent } from '@mui/material';
import { School, Add, Upload, Edit, Delete } from '@mui/icons-material';
import TableComponent from 'Component/Table';
import { TrainingRequests } from 'requests/TrainingRequests';
import { useDispatch, useSelector } from 'react-redux';
import FormModal from 'Component/FormModal';
import AddTrainerForm from 'Component/MultiStepTrainingForms/TrainingForm/AddTrainerForm';
import AddTrainingTypeForm from 'Component/MultiStepTrainingForms/TrainingForm/AddTrainingTypeForm';
import { fetchAllTrainingTypes } from 'thunks/trainingThunks/thunk';
import GlobalConfirmationBox from 'Component/AlertDialog/GlobalConfirmationBox';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { removeTrainer } from 'reducer/trainersSlice';
import UploadNomination from './UploadNomination';

const TrainingTypes = () => {
  const dispatch = useDispatch();

  // Get trainers data from Redux
  const {
    data: { trainingTypes },
    loading,
  } = useSelector((state) => state.trainingTypePageSlice);
  // Fetch trainers on component mount
  useEffect(() => {
    dispatch(fetchAllTrainingTypes());
  }, [dispatch]);

  const [allCourses, setAllCourses] = useState([]);
  const [count, setCount] = useState(-1);

  const columns = [
    { label: 'Training Name', field: 'trainingName' },
    {
      label: 'Active',
      field: 'isActive',
      render: (row) => (
        <Switch
          checked={!!row.isActive}
          onChange={async (e) => {
            try {
              await TrainingRequests.updateTrainingType({
                trainingName: row.trainingName,
                isActive: e.target.checked,
              });
              dispatch(fetchAllTrainingTypes());
            } catch (error) {
              console.error('Error updating training type status:', error);
            }
          }}
          color="primary"
        />
      ),
    },
    {
      label: 'Action',
      field: 'edit',
      render: (row) => (
        <FormModal
          buttonName={'Edit'}
          title={'Update Training Type'}
          startIcon={<EditIcon />}
          form={
            <AddTrainingTypeForm
              row={row}
              initialData={{ trainingName: row?.trainingName, description: row?.description }}
              region={[{ regionId: row.regionId, regionName: row.regionName }]}
              disabled={['employee']}
              trigger={() => {
                dispatch(fetchAllTrainingTypes());
              }}
            />
          }
        />
      ),
    },
    // {
    //   label: "Remove",
    //   field: "action",
    //   render: (row) => (
    //     <GlobalConfirmationBox
    //       key={row.id}
    //       actionButtonName="Delete"
    //       description="Are you sure you want to remove this training type?"
    //       startIcon={<DeleteIcon />}
    //       onConfirm={(row) => {
    //         // this is a soft delete operation.
    //         let tempRow={...row}
    //         row['employee']=[
    //           {
    //             'employeeId': row.employeeId,
    //             'employeeName': row.employeeName
    //           }
    //         ]
    //         delete row['employeeId']
    //         delete row['employeeName']
    //         TrainingRequests.updateTrainee(row)
    //          .then(() => {
    //             console.log("updating list")
    //             dispatch(removeTrainer(tempRow));
    //           })
    //           .catch((error) => {
    //             console.error("Error deleting trainer:", error);
    //           });
    //       }}
    //       data={{ ...row, isTrainer: false }}
    //     />
    //   ),
    // },
  ];

  const tableName = 'TrainingList';
  console.log('allCourses', allCourses);
  const handlePageChange = (newPage, newLimit) => {
    console.log('newPage', newPage, newLimit);
    // setPage(newPage);
    // setLimit(newLimit);
    // handleGetTableData();
  };

  return (
    <Layout>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          p: { xs: 2, md: 3 },
        }}
      >
        {/* Professional Header */}
        <Box
          sx={{
            mb: 2,
            background: '#ffffff',
            borderRadius: '8px',
            p: 2,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0',
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                sx={{
                  color: '#1e293b',
                  mb: 0.25,
                }}
              >
                Training Types
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontWeight: '400' }}>
                Manage and configure different types of training programs
              </Typography>
            </Box>
            <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
              <FormModal buttonName={'Upload Nomination'} title="" form={<UploadNomination />} />
              <FormModal
                buttonName={'Add New Training'}
                title={'Add Training type'}
                form={
                  <AddTrainingTypeForm
                    // region={regions}
                    trigger={() => {
                      dispatch(fetchAllTrainingTypes());
                    }}
                  />
                }
              />
            </Box>
          </Box>
        </Box>

        {/* Table Section */}
        <Card
          sx={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            border: '1px solid #e2e8f0',
            borderRadius: '16px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            overflow: 'hidden',
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <TableComponent
              tableData={trainingTypes}
              setTableData={setAllCourses}
              columns={columns}
              tableName={tableName}
              count={count}
              useWholeRowClicked={false}
              rowClickedKey={'batchId'}
              naviagtionPath={`/training/?batch=`}
              enableLocalSearch={true}
              onPageChange={handlePageChange}
            />
          </CardContent>
        </Card>
      </Box>
    </Layout>
  );
};

export default TrainingTypes;
